import { render, staticRenderFns } from "./RedesignTeamDetailsReslut.vue?vue&type=template&id=bacdfce6&scoped=true"
import script from "./RedesignTeamDetailsReslut.vue?vue&type=script&lang=js"
export * from "./RedesignTeamDetailsReslut.vue?vue&type=script&lang=js"
import style0 from "./RedesignTeamDetailsReslut.vue?vue&type=style&index=0&id=bacdfce6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignTeamDetailsReslut.vue?vue&type=style&index=1&id=bacdfce6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacdfce6",
  null
  
)

export default component.exports